export default {
  namespaced: true,
  actions: {
    async conversionLead(_, campaing) {
      try {
        const response = await window.__STARLINK.actions.convertLead(campaing)
        return response
      } catch (error) {
        console.error(error)
      }
    }
  }
}
